import { Filter } from '@empathy/search-types';
import { Facets } from '../../../models';
import { SEARCH_ACTIONS_KEYS, SEARCH_GETTERS_KEYS, SEARCH_MUTATIONS_KEYS } from '../search.const';
import { SearchAction, SearchContext } from '../search.interfaces';

export class ClearFacetsFiltersAction implements SearchAction {

  actions = {
    [SEARCH_ACTIONS_KEYS.clearFacetsFilters]: (context: SearchContext, facetsNames?: string[]) => {
      if (facetsNames) {
        this.clearFacetsFilters(facetsNames, context);
      } else {
        this.clearAllFilters(context);
      }
    },
    [SEARCH_ACTIONS_KEYS.clearAllFiltersAndSelectOne]: (context: SearchContext, filterToSelect: Filter) => {
      this.clearAllFiltersAndSelectOne(filterToSelect, context);
    }
  };

  clearFacetsFilters(facetsNames: string[], context: SearchContext) {
    facetsNames.forEach(facetName => {
      const selectedFilters: Filter[] = context.getters[SEARCH_GETTERS_KEYS.selectedFiltersByFacet][facetName];
      if (selectedFilters) {
        context.commit(SEARCH_MUTATIONS_KEYS.clearFilters, this.siftSelectedFilters(context, selectedFilters));
      }
    });
  }

  clearAllFilters(context: SearchContext) {
    const selectedFilters: Filter[] = context.getters[SEARCH_GETTERS_KEYS.selectedFilters];
    context.commit(SEARCH_MUTATIONS_KEYS.clearFilters, this.siftSelectedFilters(context, selectedFilters));
  }

  // This function is made to select filters from Suggestions that are not in the Search.facets state.
  // That's why the filter is searched by facet Name and Id.
  // It only works with First-Level filters.
  clearAllFiltersAndSelectOne(filterToSelect: Filter, context: SearchContext) {
    this.clearAllFilters(context);
    const foundFilter = this.findFilterByFacetNameAndFilterId(filterToSelect.facet.modelName, filterToSelect.id, context);
    if (foundFilter) {
      context.commit(SEARCH_MUTATIONS_KEYS.selectFilter, foundFilter);
    } else {
      const facetsWithNewFilter = Object.assign({}, context.state.facets, { [filterToSelect.facet.modelName]: filterToSelect.facet });
      context.commit(SEARCH_MUTATIONS_KEYS.setFacets, facetsWithNewFilter);
    }
  }

  siftSelectedFilters({ state, getters }: SearchContext, selectedFilters: Filter[]): Filter[] {
    const compulsoryFacets: Facets = getters[SEARCH_GETTERS_KEYS.compulsoryFacets];
    return selectedFilters
      // Sifting filter whose facet is not compulsory or has parent (is child)
      .filter(filter => !compulsoryFacets[filter.facet.modelName] || filter.parent)
      // Sifting no preselected filters. It is just to keep a no compulsory preselected in the first search
      .filter(filter => {
        const preselectedFilter = state.preSelectedFilters[filter.facet.modelName];
        return !preselectedFilter?.filters.includes(filter);
      });
  }

  findFilterByFacetNameAndFilterId(facetName: string, filterId: string, context: SearchContext): Filter {
    return context.state.facets[facetName]?.filters.find(filter => filter.id === filterId);
  }
}
